<template>
  <div class="page-card">
    <el-card>
      <div slot="header">资讯与内容管理</div>
      <el-form :inline="true" size="small" @submit.native.prevent>
        <el-form-item label="标题">
          <el-input v-model="query.title" placeholder="标题" />
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="query.type" placeholder="请选择类型" clearable style="width: 160px;">
            <el-option label="公告" value="公告" />
            <el-option label="活动" value="活动" />
            <el-option label="路况" value="路况" />
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchList">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="success" @click="openEdit()">新增资讯</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="title" label="标题" />
        <el-table-column prop="type" label="类型" width="120" />
        <el-table-column prop="createdAt" label="创建时间" width="180" />
        <el-table-column prop="status" label="状态" width="100" />
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button size="mini" @click="toggleStatus(scope.row)">
              {{ scope.row.status === '已发布' ? '下架' : '发布' }}
            </el-button>
            <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        :title="editForm.id ? '编辑资讯' : '新增资讯'"
        :visible.sync="editVisible"
        width="700px"
      >
        <el-form :model="editForm" label-width="80px">
          <el-form-item label="标题">
            <el-input v-model="editForm.title" />
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="editForm.type" placeholder="请选择类型" style="width: 100%;">
              <el-option label="公告" value="公告" />
              <el-option label="活动" value="活动" />
              <el-option label="路况" value="路况" />
            </el-select>
          </el-form-item>
          <el-form-item label="图片">
            <el-upload
              :key="uploadKey"
              class="news-edit-upload avatar-uploader"
              action=""
              list-type="picture-card"
              multiple
              :file-list="imageFileList"
              :http-request="uploadNewsImage"
              :before-upload="beforeNewsImageUpload"
              :on-remove="handleImageRemove"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="news-upload-tip">可多张上传；小程序详情页会展示全部图片</div>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="editForm.status" placeholder="请选择状态">
              <el-option label="已发布" value="已发布" />
              <el-option label="草稿" value="草稿" />
              <el-option label="下线" value="下线" />
            </el-select>
          </el-form-item>
          <el-form-item label="内容">
            <el-input
              type="textarea"
              :rows="8"
              v-model="editForm.content"
              placeholder="内容"
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitEdit">保 存</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request, {
  resolveUploadedFileUrl,
  pickUploadResponsePayload,
  normalizeMediaUrl
} from '@/api/request'

export default {
  name: 'NewsList',
  data() {
    return {
      query: {
        title: '',
        type: ''
      },
      dateRange: [],
      list: [],
      editVisible: false,
      uploadKey: 0,
      imageFileList: [],
      editForm: {
        id: null,
        title: '',
        type: '',
        coverImage: '',
        images: [],
        status: '已发布',
        content: ''
      }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      const params = {
        title: this.query.title,
        type: this.query.type
      }
      if (this.dateRange && this.dateRange.length === 2) {
        params.start = this.dateRange[0]
        params.end = this.dateRange[1]
      }
      request.get('/news', { params }).then(res => {
        const data = res.data || res
        this.list = (data && data.items) || []
      })
    },
    resetQuery() {
      this.query.title = ''
      this.query.type = ''
      this.dateRange = []
      this.fetchList()
    },
    /** 仅 http(s) 外链可给小程序用；过滤 base64/blob */
    isHttpUrl(u) {
      return u && typeof u === 'string' && /^https?:\/\//i.test(u.trim())
    },
    buildImageFileList(cover, imgs) {
      const merged = []
      const add = u => {
        const s = (u || '').trim()
        if (s && this.isHttpUrl(s) && merged.indexOf(s) === -1) merged.push(s)
      }
      add(cover)
      ;(imgs || []).forEach(add)
      return merged.map((u, idx) => ({ name: `img_${idx + 1}`, url: u }))
    },
    openEdit(row) {
      if (row && row.id) {
        request.get(`/news/${row.id}`).then(res => {
          const data = (res.data || res) || {}
          const coverRaw = (data.coverImage || data.cover_image || '').trim()
          const cover = normalizeMediaUrl(coverRaw) || coverRaw
          const imgs = Array.isArray(data.images) ? data.images : []
          const imgsNorm = imgs.map(u => normalizeMediaUrl(u) || u)
          this.editForm = {
            id: data.id,
            title: data.title || '',
            type: data.type || '',
            status: data.status || '已发布',
            content: data.content || '',
            coverImage: this.isHttpUrl(cover) ? cover : '',
            images: imgsNorm.filter(u => this.isHttpUrl(u))
          }
          this.imageFileList = this.buildImageFileList(
            this.editForm.coverImage,
            this.editForm.images.length ? this.editForm.images : imgsNorm
          )
          this.uploadKey += 1
          this.editVisible = true
        }).catch(() => {
          this.$message.error('获取资讯详情失败')
        })
      } else {
        this.editForm = {
          id: null,
          title: '',
          type: '',
          coverImage: '',
          images: [],
          status: '已发布',
          content: ''
        }
        this.imageFileList = []
        this.uploadKey += 1
        this.editVisible = true
      }
    },
    toggleStatus(row) {
      const target = row.status === '已发布' ? '草稿' : '已发布'
      request
        .put(`/news/${row.id}/status`, { status: target })
        .then(() => {
          this.$message.success('操作成功')
          this.fetchList()
        })
    },
    submitEdit() {
      if (!this.editForm.title || !this.editForm.content || !this.editForm.type) {
        this.$message.warning('请填写标题、类型和内容')
        return
      }
      const urls = (this.imageFileList || []).map(f => f.url).filter(u => this.isHttpUrl(u))
      if (!urls.length) {
        this.$message.warning('请至少上传一张图片（需为网络地址，本地上传后自动获得）')
        return
      }
      const coverImage = urls[0]
      const payload = {
        title: this.editForm.title,
        type: this.editForm.type,
        status: this.editForm.status,
        content: this.editForm.content,
        coverImage,
        images: urls
      }
      const req = this.editForm.id
        ? request.put(`/news/${this.editForm.id}`, payload)
        : request.post('/news', payload)
      req.then(() => {
        this.$message.success('保存成功')
        this.editVisible = false
        this.fetchList()
      })
    },
    remove(row) {
      this.$confirm('确认删除该资讯吗？', '提示', { type: 'warning' }).then(() => {
        request.delete(`/news/${row.id}`).then(() => {
          this.$message.success('删除成功')
          this.fetchList()
        })
      })
    },
    beforeNewsImageUpload(file) {
      const okType = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif'].includes(file.type)
      if (!okType) {
        this.$message.error('仅支持 png/jpg/jpeg/webp/gif')
        return false
      }
      if (file.size / 1024 / 1024 > 5) {
        this.$message.error('单张不超过 5MB')
        return false
      }
      return true
    },
    uploadNewsImage(req) {
      const form = new FormData()
      form.append('file', req.file)
      request
        .post('/upload', form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(res => {
          const data = pickUploadResponsePayload(res)
          const url = resolveUploadedFileUrl(data)
          if (!url) throw new Error('empty url')
          const next = [...(this.imageFileList || []), { name: req.file.name || 'img', url }]
          this.imageFileList = next
          const urls = next.map(x => x.url).filter(u => this.isHttpUrl(u))
          this.editForm.images = urls
          this.editForm.coverImage = urls[0] || ''
          req.onSuccess && req.onSuccess({ url })
        })
        .catch(() => {
          this.$message.error('图片上传失败')
          req.onError && req.onError(new Error('upload fail'))
        })
    },
    handleImageRemove(file, fileList) {
      this.imageFileList = fileList || []
      const urls = (fileList || []).map(x => x.url).filter(u => this.isHttpUrl(u))
      this.editForm.images = urls
      this.editForm.coverImage = urls[0] || ''
    }
  }
}
</script>

<style scoped>
.news-upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 6px;
  line-height: 1.4;
}
/* 关闭资讯编辑里图片列表的过渡/动画（加载时不闪、不淡入） */
.news-edit-upload >>> .el-upload-list--picture-card .el-upload-list__item {
  transition: none !important;
  animation: none !important;
}
.news-edit-upload >>> .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  transition: none !important;
}
.news-edit-upload >>> .el-upload-list__item-status-label {
  transition: none !important;
}
.news-edit-upload >>> .el-upload--picture-card {
  transition: none !important;
}
</style>
